module.exports = __webpack_public_path__ + "static/media/1to1-available-usa.60b204ca.png";